import useApi from '../../components/js/Composables/useApi'
import type { PaginatedNotifications, NotificationParams, Notification, GroupedByType } from '../../Types/notification'

export function useNotificationApi() {
  const { getJSON, patchJSON } = useApi()

  async function fetchUnreadCount(team?: boolean): Promise<number> {
    const query = team ? `?team=true` : ''
    const response = await getJSON(`notifications/count/unread${query}`)
    return response ?? 0
  }

  async function fetchPaginatedNotifications(params?: NotificationParams): Promise<PaginatedNotifications> {
    const queryParams: Record<string, any> = { page: 1, limit: params?.limit, ...params }
    const query = `?${new URLSearchParams(queryParams)}`
    const response: PaginatedNotifications = await getJSON(`notifications${query}`)
    return response ?? { total: 0, items: [] }
  }

  async function fetchGroupedByType(team?: boolean): Promise<GroupedByType[]> {
    const query = team ? `?team=true` : ''
    const response = await getJSON(`notifications/grouped${query}`)
    return response ?? []
  }

  async function markAsRead(notification: Notification): Promise<Notification> {
    await patchJSON(`notifications/${notification.id}`)

    return {
      ...notification,
      isRead: true,
    }
  }

  return {
    fetchUnreadCount,
    fetchPaginatedNotifications,
    fetchGroupedByType,
    markAsRead,
  }
}
